import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import axios from "axios";
import FormField from "components/FormField";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { URL_API } from "config";
import { useAuthContext } from "context/AuthContext";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function CooperatedFormMessages({ label }) {
  const { user } = useAuthContext();

  const [step, setStep] = useState(user?.profile !== 99 ? true : false);

  const { uuid } = useParams();

  const navigate = useNavigate();

  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState();

  async function getDescriptions(user_uuid, uuid) {
    const data = await axios.get(
      URL_API + `/description/${user_uuid}/${uuid}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Tag")}`,
        },
      }
    );

    setMessages(data?.data);
  }

  async function createDescription(mesg) {
    const body = {
      cooperated_uuid: uuid,
      user_uuid: user?.uuid,
      description: mesg,
      step: 8,
    };
    await axios
      .post(URL_API + `/description`, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Tag")}`,
        },
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      })
      .finally(() => {
        getDescriptions(user.uuid, uuid);
      });
  }

  useEffect(() => {
    (async () => await getDescriptions(user?.uuid, uuid))();
  }, [user?.uuid, uuid]);

  return (
    <Accordion
      expanded={step}
      onChange={() => setStep(!step)}
      slotProps={{ transition: { timeout: 400 } }}
      sx={{
        "& .MuiAccordion-region": {
          height: step ? "auto" : 0,
        },
        "& .MuiAccordionDetails-root": {
          display: step ? "block" : "none",
        },
      }}
    >
      <MDBox p={3}>
        <MDBox>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography>{label}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MDBox mt={1.625}>
              <FormField
                type="text"
                label="Mensagem"
                name="message"
                value={message}
                multiline
                rows={5}
                placeholder="Mensagem"
                onChange={(e) => setMessage(e.target.value)}
              />
            </MDBox>
            <div
              style={{
                marginBottom: "20px",
                textAlignLast: "right",
              }}
            >
              <MDButton
                disabled={!message}
                variant="gradient"
                color="success"
                onClick={() => {
                  createDescription(message);
                }}
              >
                adicionar
              </MDButton>
            </div>
            {messages.map((el) => {
              if (el.user_name === "Eu") {
                return (
                  <div style={{ marginBottom: "20px" }}>
                    <MDBox
                      bgColor="light"
                      color="dark"
                      variant="gradient"
                      borderRadius="lg"
                      shadow="lg"
                      opacity={1}
                      p={2}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "10px",
                        }}
                      >
                        <p
                          style={{
                            fontFamily: `Arial`,
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {el.user_name}
                        </p>
                        <p
                          style={{
                            fontFamily: `Arial`,
                            fontSize: "13px",
                          }}
                        >
                          {moment(el.created_at).format("hh:mm DD/MM/YYYY")}
                        </p>
                      </div>
                      <p
                        style={{
                          fontFamily: `Arial`,
                          fontSize: "15px",
                        }}
                      >
                        {el.description}
                      </p>
                    </MDBox>
                  </div>
                );
              } else {
                return (
                  <div style={{ marginBottom: "20px" }}>
                    <MDBox
                      variant="gradient"
                      borderRadius="lg"
                      shadow="lg"
                      opacity={1}
                      p={2}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "10px",
                        }}
                      >
                        <p
                          style={{
                            fontFamily: `Arial`,
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {el.user_name}
                        </p>
                        <p
                          style={{
                            fontFamily: `Arial`,
                            fontSize: "13px",
                          }}
                        >
                          {moment(el.created_at).format("hh:mm DD/MM/YYYY")}
                        </p>
                      </div>
                      <p
                        style={{
                          fontFamily: `Arial`,
                          fontSize: "15px",
                        }}
                      >
                        {el.description}
                      </p>
                    </MDBox>
                  </div>
                );
              }
            })}
          </AccordionDetails>
        </MDBox>
      </MDBox>
    </Accordion>
  );
}
